export default "__VITE_PUBLIC_ASSET__11bbf8bc__"